import { CommonEnums } from '../../common.enums';
import { Native_Db_Seq } from './native_db_seq'
import { ArrayUtil } from '../utils/array.util';

export class DBSeq {
    native_Db_Seq: Native_Db_Seq;

    fldr_Id: number;
    lockBy: string;
    mode_Ind: string;
    change_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    reusableFlag: string;
    isDependent: boolean;
    isLinkExist: boolean;
    fldrNm: string;
    imageUrl: string;
    recExists: boolean;
    dependent_Ids: Array<number>;
    selectedFlag: string;
    fldr_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.native_Db_Seq = new Native_Db_Seq();

        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.unlock_Ind = CommonEnums.unlock_Ind.UNSET;
        this.error_Cd = CommonEnums.defaults.STRING_VAL_NO;
        this.error_Msg = CommonEnums.defaults.STRING_VAL_NO;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_VAL_NO;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.isDependent = false;
        this.isLinkExist = false;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.imageUrl = CommonEnums.defaults.STRING_VAL_NO;
        this.recExists = false;
        this.dependent_Ids = new Array<number>();
        this.selectedFlag = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Cd = CommonEnums.defaults.STRING_VAL_NO;
    }

    static parse(dBSeqTmp: DBSeq): DBSeq {
        let dBSeq: DBSeq = new DBSeq();
        dBSeq.copyFrom(dBSeqTmp as DBSeq);
        return dBSeq;
    }

    copy(): DBSeq {
        let dBSeqTmp: DBSeq = new DBSeq();

        this.native_Db_Seq = dBSeqTmp.native_Db_Seq.copy();

        dBSeqTmp.fldr_Id = this.fldr_Id;
        dBSeqTmp.lockBy = this.lockBy;
        dBSeqTmp.mode_Ind = this.mode_Ind;
        dBSeqTmp.change_Ind = this.change_Ind;
        dBSeqTmp.unlock_Ind = this.unlock_Ind;
        dBSeqTmp.error_Cd = this.error_Cd;
        dBSeqTmp.error_Msg = this.error_Msg;
        dBSeqTmp.ref_Id = this.ref_Id;
        dBSeqTmp.ref_Cd = this.ref_Cd;
        dBSeqTmp.reusableFlag = this.reusableFlag;
        dBSeqTmp.isDependent = this.isDependent;
        dBSeqTmp.isLinkExist = this.isLinkExist;
        dBSeqTmp.fldrNm = this.fldrNm;
        dBSeqTmp.imageUrl = this.imageUrl;
        dBSeqTmp.recExists = this.recExists;

        dBSeqTmp.dependent_Ids = ArrayUtil.getInstance().copy(this.dependent_Ids);

        dBSeqTmp.selectedFlag = this.selectedFlag;
        dBSeqTmp.fldr_Cd = this.fldr_Cd;

        return dBSeqTmp;
    }

    copyFrom(dBSeqTmp: DBSeq): void {
        this.native_Db_Seq.copyFrom(dBSeqTmp.native_Db_Seq);

        this.fldr_Id = dBSeqTmp.fldr_Id;
        this.lockBy = dBSeqTmp.lockBy;
        this.mode_Ind = dBSeqTmp.mode_Ind;
        this.change_Ind = dBSeqTmp.change_Ind;
        this.unlock_Ind = dBSeqTmp.unlock_Ind;
        this.error_Cd = dBSeqTmp.error_Cd;
        this.error_Msg = dBSeqTmp.error_Msg;
        this.ref_Id = dBSeqTmp.ref_Id;
        this.ref_Cd = dBSeqTmp.ref_Cd;
        this.reusableFlag = dBSeqTmp.reusableFlag;
        this.isDependent = dBSeqTmp.isDependent;
        this.isLinkExist = dBSeqTmp.isLinkExist;
        this.fldrNm = dBSeqTmp.fldrNm;
        this.imageUrl = dBSeqTmp.imageUrl;
        this.recExists = dBSeqTmp.recExists;

        ArrayUtil.getInstance().copyFrom(this.dependent_Ids, dBSeqTmp.dependent_Ids);

        this.selectedFlag = dBSeqTmp.selectedFlag;
        this.fldr_Cd = dBSeqTmp.fldr_Cd;
    }

    compare(dBSeqTmp: DBSeq): string {
        let diffString: string = this.native_Db_Seq.compare(dBSeqTmp.native_Db_Seq);
        if (diffString != '') return diffString;

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DBSeq [native_Db_Seq=" + this.native_Db_Seq.toString(isNotCompare) + ", isDependent=" + this.isDependent +
            ", isLinkExist=" + this.isLinkExist + ", recExists=" + this.recExists +
            ", dependent_Ids=" + ArrayUtil.getInstance().toString(this.dependent_Ids) +
            ", selectedFlag=" + this.selectedFlag + ", fldr_Cd=" + this.fldr_Cd + ", resuableFlag=" + this.reusableFlag;

        if (isNotCompare) {
            str += ", lockBy=" + this.lockBy + ", mode_Ind=" + this.mode_Ind + ", unlock_Ind=" + this.unlock_Ind +
                ", change_Ind=" + this.change_Ind + ", fldr_Id=" + this.fldr_Id + ", fldrNm=" + this.fldrNm + ", imageUrl=" + this.imageUrl +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd;
        }

        str += ']';
        return str;
    }
}